module.exports = __webpack_public_path__ + "static/media/998591.9d99dc8e.jpg";